import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Outlet, Navigate, Link } from 'react-router-dom';

const AdminLayout: React.FC = () => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check admin custom claim
  if (!isAdmin) {
      return (
          <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center">
              <h1 className="text-2xl font-bold mb-2">ACCESS DENIED</h1>
              <p className="text-gray-500 mb-4">You do not have permission to view this area.</p>
              <Link to="/" className="underline">Return Home</Link>
          </div>
      );
  }

  return (
    <div className="min-h-screen bg-brand-light">
      <nav className="bg-brand-black text-white p-4 flex justify-between items-center">
        <h1 className="font-heading text-xl tracking-widest">ADMIN PORTAL</h1>
        <div className="flex items-center gap-4">
            <Link to="/admin/inventory" className="text-sm font-heading tracking-widest hover:text-gray-500">INVENTORY</Link>
            <Link to="/admin/orders" className="text-sm font-heading tracking-widest hover:text-gray-500">ORDERS</Link>
            <Link to="/admin/content" className="text-sm font-heading tracking-widest hover:text-gray-500">SITE CONTENT</Link>
            <Link to="/admin/email" className="text-sm font-heading tracking-widest hover:text-gray-500">EMAIL</Link>
            <Link to="/admin/vault" className="text-sm font-heading tracking-widest hover:text-gray-500">VAULT</Link>
            <Link to="/admin/settings" className="text-sm font-heading tracking-widest hover:text-gray-500">SETTINGS</Link>
          </div>
      </nav>
      <main className="p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
